import { Box, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ComercialInterfaceHeader from "@/components/comercial/ComercialInterfaceHeader";
import { sharedStyles } from "@/styles/shared";
import gatewayApi from "@/services/api/Gateway";
import { GatewayInfo } from "@/services/api/Gateway/types";

interface BankingDataFormProps {
  refs: Record<string, React.RefObject<HTMLInputElement>>;
  accountType: string;
  setAccountType: (v: string) => void;
  pixKeyType: string;
  setPixKeyType: (v: string) => void;
  gatewayId: string;
  setGatewayId: (v: string) => void;
  defaultValueGatewayId?: string;
  defaultValueBank?: string;
  defaultValueIssuer?: string;
  defaultValueIssuerDigit?: string;
  defaultValueAccountNumber?: string;
  defaultValueBankDigit?: string;
  defaultValuePixKey?: string;
}

export const BankingDataForm = ({
  refs,
  accountType,
  setAccountType,
  pixKeyType,
  setPixKeyType,
  gatewayId,
  setGatewayId,
  defaultValueGatewayId,
  defaultValueBank,
  defaultValueIssuer,
  defaultValueIssuerDigit,
  defaultValueAccountNumber,
  defaultValueBankDigit,
  defaultValuePixKey,
}: BankingDataFormProps) => {
  const [gateways, setGateways] = useState<GatewayInfo[]>([]);

  useEffect(() => {
    gatewayApi.list().then(setGateways).catch(() => setGateways([]));
  }, []);

  return (
    <>
      <ComercialInterfaceHeader title="Dados Bancários e Gateway" />
      <Box sx={sharedStyles.verticalContent}>
        <TextField
          size="small"
          select
          label="Gateway de Pagamento"
          value={gatewayId}
          onChange={(e) => setGatewayId(e.target.value)}
          SelectProps={{ native: true }}
          fullWidth
          InputLabelProps={{ shrink: true }}
        >
          <option value="">-- Gateway padrão --</option>
          {gateways.map((g) => (
            <option key={g.id} value={g.id}>
              {g.name} {g.description ? `— ${g.description}` : ""}
            </option>
          ))}
        </TextField>

        <Box sx={sharedStyles.dividedFormContainer}>
          <TextField
            size="small"
            label="Banco (Código)"
            inputRef={refs.bank}
            fullWidth
            defaultValue={defaultValueBank}
          />
          <TextField
            size="small"
            label="Agência"
            inputRef={refs.issuer}
            fullWidth
            defaultValue={defaultValueIssuer}
          />
          <TextField
            size="small"
            label="Dígito Agência"
            inputRef={refs.issuerDigit}
            fullWidth
            defaultValue={defaultValueIssuerDigit}
          />
        </Box>

        <Box sx={sharedStyles.dividedFormContainer}>
          <TextField
            size="small"
            label="Número da Conta"
            inputRef={refs.accountNumber}
            fullWidth
            defaultValue={defaultValueAccountNumber}
          />
          <TextField
            size="small"
            label="Dígito Conta"
            inputRef={refs.bankDigit}
            fullWidth
            defaultValue={defaultValueBankDigit}
          />
          <TextField
            size="small"
            select
            label="Tipo de Conta"
            value={accountType}
            onChange={(e) => setAccountType(e.target.value)}
            SelectProps={{ native: true }}
            fullWidth
            InputLabelProps={{ shrink: true }}
          >
            <option value="CHECKING_ACCOUNT">Conta Corrente</option>
            <option value="SAVINGS_ACCOUNT">Conta Poupança</option>
          </TextField>
        </Box>

        <Typography variant="subtitle2" sx={{ mt: 2, color: "text.secondary" }}>
          Configuração de Transferência (PIX)
        </Typography>

        <Box sx={sharedStyles.dividedFormContainer}>
          <TextField
            size="small"
            select
            label="Tipo de Chave PIX"
            value={pixKeyType}
            onChange={(e) => setPixKeyType(e.target.value)}
            SelectProps={{ native: true }}
            sx={{ width: "35%" }}
            InputLabelProps={{ shrink: true }}
          >
            <option value="CPF">CPF</option>
            <option value="CNPJ">CNPJ</option>
            <option value="EMAIL">E-mail</option>
            <option value="PHONE">Telefone</option>
            <option value="RANDOM_KEY">Chave Aleatória</option>
          </TextField>
          <TextField
            size="small"
            label="Chave PIX"
            inputRef={refs.pixKey}
            sx={{ width: "65%" }}
            defaultValue={defaultValuePixKey}
          />
        </Box>
      </Box>
    </>
  );
};
